export default "__VITE_ASSET__DxweetGj__"